import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const SupplierRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.supplier_master_create === true ||
    permissions.supplier_master_edit === true ||
    permissions.supplier_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default SupplierRouteMiddleware;
